import { WalletProvider } from "@advisa/wallet";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import { LanguageProvider } from "./components/languageToggle";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { usePageViewTracking } from "./hooks/api/usePageviewTracking";
import * as Sentry from "@sentry/react";
import { version } from "../package.json";

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const queryClient = new QueryClient();

const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
});

Sentry.init({
  dsn: "https://1e05b103818022051bdd3e99f498b345@o451393.ingest.us.sentry.io/4508726098264065",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.tanstackRouterBrowserTracingIntegration(router),
  ],
  tracesSampleRate: import.meta.env.MODE === "production" ? 0.05 : 1.0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1,
  environment: import.meta.env.MODE,
  release: version,
  ignoreErrors: [],
  denyUrls: [],
});

const App = () => {
  usePageViewTracking();

  return (
    <WalletProvider brand="Sambla">
      <QueryClientProvider client={queryClient}>
        <LanguageProvider>
          <RouterProvider router={router} />
        </LanguageProvider>
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </WalletProvider>
  );
};

export default App;
